(() => {
    // slick default setting
    let defaultSettings = {
        loop: true,
        speed: 700,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    document.querySelectorAll(".swiper-slider").forEach(slider => {
        new Swiper(slider, Object.assign({}, defaultSettings, slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {}));
    });

    let swiperGallery = new Swiper(".swiper-gallery", {
        loop: true,
        speed: 700,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        spaceBetween: 10,
        slidesPerView: 1.08,
        navigation: {
            prevEl: ".swiper-gallery-next",
            nextEl: ".swiper-gallery-prev"
        },
        breakpoints: {
            600: {
                slidesPerView: "auto",
                autoplay: {
                    reverseDirection: true
                }
            }
        }
    });

    const galleryObserver = new ResizeObserver(() => {
        swiperGallery.update();
    });

    swiperGallery.slides.forEach(slide => galleryObserver.observe(slide));

    // Slider Cards
    let swiperCards = document.querySelectorAll('.swiper-cards');

    if(swiperCards) {
        swiperCards = new Swiper(".swiper-cards", {
            loop: true,
            speed: 700,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            effect: "slide",
            spaceBetween: 10,
            slidesPerView: 1.2,
            centeredSlides: true,
            breakpoints: {
                600: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3,
                    centeredSlides: false
                },
                900: {
                    slidesPerView: 4,
                    centeredSlides: false
                }
            }
        });
    }
    
    // Slider Columns
    let swiperColumns = document.querySelectorAll('.swiper-columns');

    if(swiperColumns) {
        swiperColumns = new Swiper(".swiper-columns", {
            loop: true,
            speed: 700,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            spaceBetween: 40,
            slidesPerView: 1,
            navigation: {
                prevEl: ".swiper-columns-prev",
                nextEl: ".swiper-columns-next"
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            }
        });
    }
})();